import React from 'react'
import AdminInventoryManagerViewModel from 'admin/inventory/InventoryManagerViewModel'
import { observer } from 'mobx-react'
import { Table, TableBody, TableHead, TableHeader } from 'components/Table'
import styles from './InventoryTable.sass'
import InventoryRow from '../InventoryRow'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import { ColumnId } from '../../InventoryTableColumns'

interface InventoryTableProps {
  vm: AdminInventoryManagerViewModel
}

/**
 * Maps column names to their respective styles.
 */
const inventoryTableColumnStyles: Record<ColumnId, any> = {
  [ColumnId.ServiceItem]: styles.titleColumn,
  [ColumnId.Global]: styles.globalColumn,
  [ColumnId.Hidden]: styles.hiddenColumn,
  [ColumnId.LastUpdatedBy]: styles.lastUpdatedColumn,
  [ColumnId.ServiceType]: styles.serviceTypeColumn,
  [ColumnId.Version]: styles.numberColumn,
  [ColumnId.VersionCreated]: styles.lastUpdatedColumn,
  [ColumnId.Courtesy]: styles.numberColumn,
  [ColumnId.PriceType]: styles.typeColumn,
  [ColumnId.SupportingItems]: styles.supportingItemsColumn,
  [ColumnId.Price]: styles.pricingColumn,
  [ColumnId.ProPrice]: styles.pricingColumn,
  [ColumnId.Actions]: styles.actionsColumn,
}

export default observer(function InventoryTable({ vm }: InventoryTableProps) {
  const columns = vm.columns
  const scrollProvider = vm.searcher.scrollProvider

  return (
    <>
      <Table striped>
        <TableHead className={styles.tableHead}>
          {columns.map((col) => (
            <TableHeader
              className={inventoryTableColumnStyles[col.id]}
              align={col.align}
              key={col.id}
            >
              {col.header}
            </TableHeader>
          ))}
        </TableHead>
        <TableBody>
          {vm.serviceItems.map((item) => (
            <InventoryRow vm={vm} inventoryItem={item} key={item.id} />
          ))}
        </TableBody>
      </Table>
      {!scrollProvider.isDone && (
        <InfiniteScrollLoader scrollProvider={scrollProvider} />
      )}
    </>
  )
})
